/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MyHistoryState } from 'store/modules/my_history_store/types';
import ListItensFollowups from 'components/atoms/list_itens_followups';
import Loader from 'components/atoms/loader';
import Pagination from 'components/atoms/pagination';

interface FollowupsListProps {
  setPageFollowup: React.Dispatch<React.SetStateAction<number>>;
  pageFollowup: number;
}

const FollowupsList = (props: FollowupsListProps) => {
  const { setPageFollowup, pageFollowup } = props;
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);

  const { my_history, request_followups } = useSelector<ApplicationState, MyHistoryState>(
    (state) => state.session.my_history,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setPageFollowup(currentPage);
    }
  };

  return (
    <div className="card">
      <h6 className="card-title m-3 ml-2 font-weight-bold">Citação em Acompanhamentos</h6>
      {request_followups?.loading && (
        <div className="p-4">
          <Loader />
        </div>
      )}
      <div>
        {request_followups?.loaded && my_history?.followups && (
          <div>
            <ListItensFollowups followups={my_history?.followups} />
            {my_history?.followups?.length > 0 && (
              <div className="border rounded-bottom border-top-0 d-print-none">
                <button
                  type="button"
                  key="btn-bidding-more-info"
                  className="btn btn-sm btn-link m-0 w-100 mb-3"
                  onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
                >
                  {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
                </button>
                {BiddingInfoToggle && (
                  <div className="row d-print-none">
                    <div className="col-md-12 px-4 mb-5">
                      <Pagination
                        postsPerPage={7}
                        totalPosts={my_history?.followups?.length}
                        paginate={paginate}
                        currentPage={pageFollowup}
                        firstAndLastPage
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FollowupsList;
